export const PREVIEW_OFFICIAL_ASSETS = [
  {
    id: 'official-jingxue', type: 'character', type_name: '角色', name: '绛雪', description: '古装女性角色参考，适合情感、悬疑和逆袭题材。',
    source: 'official', updated_at: '2026-08-13T09:20:00Z',
    files: [{ id: 'official-file-jingxue', url: '/images/vnext/case-historical-romance.jpg', mime: 'image/jpeg', kind: 'three_view', volc_status: 'Active' }],
  },
  {
    id: 'official-moon-deer', type: 'character', type_name: '角色', name: '月鹿', description: '带有冷色月光和巨物尺度的奇幻生物参考。',
    source: 'official', updated_at: '2026-08-12T08:40:00Z',
    files: [{ id: 'official-file-moon-deer', url: '/images/vnext/case-fantasy-creature.jpg', mime: 'image/jpeg', kind: 'three_view', volc_status: 'Active' }],
  },
  {
    id: 'official-astronaut', type: 'character', type_name: '角色', name: '舱外工程师', description: '适合太空危机、硬科幻和未来题材的角色参考。',
    source: 'official', updated_at: '2026-08-11T11:00:00Z',
    files: [{ id: 'official-file-astronaut', url: '/images/vnext/case-sci-fi-astronaut.jpg', mime: 'image/jpeg', kind: 'full_body', volc_status: 'Active' }],
  },
  {
    id: 'official-cloud-city', type: 'scene', type_name: '场景', name: '云上天宫', description: '东方幻想城市远景，适合国漫、仙侠和宣传片。',
    source: 'official', updated_at: '2026-08-10T10:10:00Z',
    files: [{ id: 'official-file-cloud-city', url: '/images/vnext/case-guoman-3d.jpg', mime: 'image/jpeg', kind: 'other', volc_status: null }],
  },
  {
    id: 'official-product-stage', type: 'scene', type_name: '场景', name: '新中式产品台', description: '低饱和商业布光与产品陈列空间，可用于广告视觉测试。',
    source: 'official', updated_at: '2026-08-09T09:30:00Z',
    files: [{ id: 'official-file-product-stage', url: '/images/vnext/featured-cases.jpg', mime: 'image/jpeg', kind: 'other', volc_status: null }],
  },
  {
    id: 'official-writing-room', type: 'scene', type_name: '场景', name: '都市创作室', description: '自然窗光下的现代创作空间，适合都市剧情。',
    source: 'official', updated_at: '2026-08-08T14:20:00Z',
    files: [{ id: 'official-file-writing-room', url: '/images/vnext/writing.jpg', mime: 'image/jpeg', kind: 'other', volc_status: null }],
  },
  {
    id: 'official-storyboard-wall', type: 'style', type_name: '风格', name: '分镜参考墙', description: '用于统一镜头草图、节点关系和视觉节奏的风格参考。',
    source: 'official', updated_at: '2026-08-07T12:10:00Z',
    files: [{ id: 'official-file-storyboard-wall', url: '/images/vnext/canvas.jpg', mime: 'image/jpeg', kind: 'other', volc_status: null }],
  },
  {
    id: 'official-academy', type: 'other', type_name: '图片', name: '创作课堂', description: '适合教学、幕后记录和制作过程展示的空间参考。',
    source: 'official', updated_at: '2026-08-06T09:00:00Z',
    files: [{ id: 'official-file-academy', url: '/images/vnext/academy.jpg', mime: 'image/jpeg', kind: 'other', volc_status: null }],
  },
];
